var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5642 11.6962H1.43783C1.26494 11.6962 1.09913 11.7649 0.976875 11.8872C0.854623 12.0094 0.785943 12.1752 0.785943 12.3481C0.785943 12.521 0.854623 12.6868 0.976875 12.8091C1.09913 12.9313 1.26494 13 1.43783 13H10.5642C10.7371 13 10.9029 12.9313 11.0251 12.8091C11.1474 12.6868 11.2161 12.521 11.2161 12.3481C11.2161 12.1752 11.1474 12.0094 11.0251 11.8872C10.9029 11.7649 10.7371 11.6962 10.5642 11.6962ZM1.43783 10.3925H1.4965L4.21485 10.1448C4.51262 10.1151 4.79113 9.98389 5.00362 9.77318L10.8706 3.90624C11.0983 3.66567 11.2213 3.34465 11.2128 3.01351C11.2042 2.68237 11.0648 2.36813 10.8249 2.13964L9.03878 0.353477C8.80566 0.134507 8.50018 0.00886531 8.18046 0.000451597C7.86074 -0.00796211 7.54908 0.10144 7.30477 0.307846L1.43783 6.17479C1.22711 6.38728 1.09592 6.66579 1.06625 6.96357L0.785943 9.68192C0.777161 9.7774 0.789551 9.87364 0.822228 9.96378C0.854904 10.0539 0.907064 10.1357 0.974989 10.2034C1.0359 10.2638 1.10814 10.3116 1.18756 10.3441C1.26699 10.3765 1.35203 10.393 1.43783 10.3925ZM8.13266 1.26611L9.9123 3.04575L8.60853 4.31692L6.86149 2.56988L8.13266 1.26611ZM2.3309 7.07439L6.001 3.43036L7.76109 5.19045L4.11054 8.84099L2.1549 9.02352L2.3309 7.07439Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1a35cabe67d9f7ea87527f701a5417da.svg";
export { ForwardRef as ReactComponent };